module.exports = __webpack_public_path__ + "static/img/4.899b682.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/sp/4.png
// module id = UdiN
// module chunks = 0